import React from "react";
import PropTypes from "prop-types";

const Opportunities = (props) => {
  // expect props.data.items (array of cards)
  const itemsIn =
    Array.isArray(props?.data?.items)
      ? props.data.items
      : Array.isArray(props?.data?.opportunities)
      ? props.data.opportunities
      : [];

  if (!itemsIn.length) return null;

  const normalize = (raw, i) => {
    const ctaUrl  = raw?.cta?.url || raw?.ctaUrl || "";
    const ctaText = raw?.cta?.title || raw?.ctaText || "";

    return {
      // tolerate both camelCase (via alias) and lowercase (no alias)
      bgClass: raw?.bgClass || raw?.bgclass || (i % 2 === 0 ? "bg-purple" : "bg-green"),
      labelNumber: raw?.labelNumber ?? raw?.labelnumber ?? String(i + 1).padStart(2, "0"),
      labelText: raw?.labelText || raw?.labeltext || "",
      title: raw?.title || "",
      description: raw?.description ?? raw?.text ?? "",
      ctaUrl,
      ctaText,
    };
  };

  const Block = ({ b }) => (
    <div className="feature-card">
      <div className="d-flex mb-6">
        <span className={`zg-label ${b.bgClass} text-black me-2`}>{b.labelNumber}</span>
        {b.labelText ? (
          <span className={`zg-label ${b.bgClass} text-black`}>{b.labelText}</span>
        ) : null}
      </div>
      {b.title ? <h2 className="h3 mb-6 rm-title">{b.title}</h2> : null}
      {b.description ? <p className="mb-6 rm-md-text">{b.description}</p> : null}
      {b.ctaUrl && b.ctaText ? (
        <a href={b.ctaUrl} className="btn-outline-white btn-lg btn">{b.ctaText}</a>
      ) : null}
    </div>
  );

  return (
    <section>
      <div className="container pt-lg-16 mb-lg-16 pt-11 mb-11">
        <div className="row mb-lg-10 mb-11">
          {itemsIn.map((it, i) => {
            const b = normalize(it, i);
            return (
              <div className="col-lg-6 col-md-12" key={i}>
                <Block b={b} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

Opportunities.propTypes = {
  data: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        bgClass: PropTypes.string,      // or bgclass if not aliased
        labelNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        labelText: PropTypes.string,
        title: PropTypes.string,
        description: PropTypes.string,
        ctaUrl: PropTypes.string,
        ctaText: PropTypes.string,
        cta: PropTypes.shape({
          url: PropTypes.string,
          title: PropTypes.string,
          target: PropTypes.string,
        }),
      })
    ),
  }),
};

export default Opportunities;
